<app-header></app-header>
<!--<div class="project-fir-page">-->
<div class="content_wrapper">
    <div class="summary-head">
        <div class="wrapper">
            <span class="heading-period"></span>
            <div class="datepicker-wrapper">
                <div class="periodpicker-wrapper">
                </div>
                <div class="popover-wrapper">
                    <input (keydown.enter)="user_search()" type="text" id="search_term" placeholder="Name, Company or Email">
                </div>
            </div>
            <button (click)="user_search()" class="submit-mention btn" type="button">Search</button>
            <button (click)="export_user()" class="submit-mention btn" type="button">Export</button>
        </div>
    </div>
    <!--first row-->
    <div class="row">

        <div class="col col-md-12">
            <div class="summary-graph">
                <div class="summary-title">
                    <i class="fa fa-bookmark-o"></i>
                    <h2 class="">Users</h2>
                </div>
                <!--tbl sec-->
                <div class="summary-tbl project_tbl"> 
                    <table>
                        <thead>
                            <tr>
                                <td role="button" (click)="data_order_by(0)" class="{{order_by == 0 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>ID</h3><i class="fa {{table_options[0] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td role="button" (click)="data_order_by(1)" class="{{order_by == 1 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Contact Name</h3><i class="fa {{table_options[1] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td role="button" (click)="data_order_by(2)" class="{{order_by == 2 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Company</h3><i class="fa {{table_options[2] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td role="button" (click)="data_order_by(3)" class="{{order_by == 3 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>User Email</h3><i class="fa {{table_options[3] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td role="button" (click)="data_order_by(4)" class="{{order_by == 4 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Created</h3><i class="fa {{table_options[4] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td role="button" (click)="data_order_by(5)" class="{{order_by == 5 ? 'active-sort' : 'inactive-sort'}}">
                                    <div class="diff-sec">
                                        <h3>Last Active</h3><i class="fa {{table_options[5] == 'desc' ? 'fa-sort-desc' : 'fa-sort-asc'}}" aria-hidden="true"></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="diff-sec">
                                        <h3>Action</h3>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of users | paginate: { itemsPerPage: page_length, currentPage: page, totalItems: total }">
                                <td>{{user.id}}</td>
                                <td>{{user.first_name}}</td>
                                <td>{{user.company}}</td>
                                <td>{{user.email}}</td>
                                <td>{{user.created_at}}</td>
                                <td>{{user.last_active}}</td>
                                <td><a routerLink="/users/edit/{{user.id}}"><span><img src="assets/images/edit.png"></span>Edit</a>&nbsp;
                                    <a role="button" (click)="delete_user(user.id)"><span><img src="assets/images/delete.png"></span>Delete</a>
                                    <a *ngIf="user.status==1" role="button" (click)="hold_user(user.id)"><span><img src="assets/images/pause.png"></span>Hold</a>
                                    <a *ngIf="user.status==0" role="button" (click)="unhold_user(user.id)"><span><img src="assets/images/unhold.png"></span>Unhold</a>
                                </td>
                            </tr>
							<tr *ngIf="users.length == 0"><td colspan="7">No Data Found.</td></tr>
                        </tbody>
                    </table>
                </div>
                <div class="mention-card">
                    <div class="paginate_sec_bottom">
                        <pagination-controls (pageChange)="pageChanged($event)" responsive="true"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<table id="export_table" style="display:none;">
    <thead>
        <tr>
            <td>
                <div class="diff-sec">
                    <h3>ID</h3>
                </div>
            </td>
            <td>
                <div class="diff-sec">
                    <h3>Contact Name</h3>
                </div>
            </td>
            <td>
                <div class="diff-sec">
                    <h3>Company</h3>
                </div>
            </td>
            <td>
                <div class="diff-sec">
                    <h3>User Email</h3>
                </div>
            </td>
            <td>
                <div class="diff-sec">
                    <h3>Created</h3>
                </div>
            </td>
            <td>
                <div class="diff-sec">
                    <h3>Last Active</h3>
                </div>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let user of export_data">
            <td>{{user.id}}</td>
            <td>{{user.first_name}}</td>
            <td>{{user.company}}</td>
            <td>{{user.email}}</td>
            <td>{{user.created_at}}</td>
            <td>{{user.last_active}}</td>
        </tr>
    </tbody>
</table>
<!--</div>-->
<app-footer></app-footer>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgb(199, 28, 109)" type="square-loader" [fullScreen]="true"></ngx-spinner>
